// START A/B TEST PLGRWEB-1340 : Display show/movie titles on search
export const SEARCH_TITLE_TEST_VARIANT = 'titles';
// END A/B TEST PLGRWEB-1340 : Display show/movie titles on search
